(function () {
  if (customElements.get("accordion-component")) {
    return;
  }

  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener("click", (event) => {
        event.preventDefault();
        const clickedTitle = event.target.closest(".accordion-component__item-title");
        if (!clickedTitle) return;

        const clickedItem = clickedTitle.parentElement;
        
        // Toggle active class on clicked item
        clickedItem.classList.toggle("is-active");

        // Remove active class from siblings
        const siblings = Array.from(this.querySelectorAll(".accordion-component__item"));
        siblings.forEach(item => {
          if (item !== clickedItem) {
            item.classList.remove("is-active");
          }
        });
      });
    }
  }

  customElements.define("accordion-component", AccordionComponent);

  // --- Hash-driven open + scroll (e.g. RTE links like <a href="#how-to-use">) ---

  // Mobile only — matches Dawn's 750px breakpoint (see scroll-navigation.js).
  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function getHeaderHeight() {
    const header = document.querySelector(".header-wrapper");
    return header ? header.offsetHeight : 0;
  }

  // Mobile docks the scroll navigation bar under the header, so a section has
  // to clear both. The nudge absorbs sub-pixel rounding (see scroll-navigation.js).
  const SCROLL_NUDGE = 3;

  function getScrollNavHeight() {
    const bar = document.querySelector("scroll-navigation.is-visible");
    return bar ? bar.offsetHeight : 0;
  }

  // Resolve the section targeted by a slug, or null. Sections are matched on
  // their Scroll ID, the same attribute the scroll navigation bar targets.
  function sectionForSlug(slug) {
    const el = document.querySelector(
      `[data-scroll-target="${CSS.escape(slug)}"]`,
    );
    return el ? { section: el } : null;
  }

  // Resolve the accordion targeted by a slug, or null. Only the collapsible
  // tabs inside main-product are anchorable — every other accordion is reached
  // through its section's Scroll ID.
  function accordionForSlug(slug) {
    const el = document.getElementById(slug);
    if (!el || !el.closest(".product__section-wrapper")) return null;

    if (el.matches("accordion-component")) {
      return {
        anchor: el,
        wrapper: el,
        item: el.querySelector(".accordion-component__item"),
      };
    }

    const wrapper = el.closest("accordion-component");
    if (el.matches(".accordion-component__item") && wrapper) {
      return { anchor: el, wrapper: wrapper, item: el };
    }

    return null;
  }

  // Sections take priority over accordions when a slug matches both.
  function targetForSlug(slug) {
    if (!slug) return null;
    return sectionForSlug(slug) || accordionForSlug(slug);
  }

  // Badges name their anchors by type: the section anchor wins when that
  // section is on the page, otherwise the accordion anchor gets a turn. Neither
  // is looked up in the other's namespace. Untyped links (RTE, deep links) have
  // no such hint and keep the section-then-accordion lookup on their slug.
  function resolveLink(link) {
    const sectionSlug = link.dataset.sectionAnchor;
    const accordionSlug = link.dataset.accordionAnchor;

    if (!sectionSlug && !accordionSlug) {
      const slug = (link.getAttribute("href") || "").replace(/^#/, "");
      const target = targetForSlug(slug);
      return target ? { slug: slug, target: target } : null;
    }

    const section = sectionSlug ? sectionForSlug(sectionSlug) : null;
    if (section) return { slug: sectionSlug, target: section };

    const accordion = accordionSlug ? accordionForSlug(accordionSlug) : null;
    if (accordion) return { slug: accordionSlug, target: accordion };

    return null;
  }

  function activateTarget(target) {
    if (!target) return;

    if (target.section) {
      const line = getHeaderHeight() + getScrollNavHeight();
      const top =
        target.section.getBoundingClientRect().top +
        window.scrollY -
        line +
        SCROLL_NUDGE;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      return;
    }

    if (target.item) {
      target.item.classList.add("is-active");

      // One open at a time, same as the click handler.
      target.wrapper
        .querySelectorAll(".accordion-component__item")
        .forEach((item) => {
          if (item !== target.item) item.classList.remove("is-active");
        });
    }

    // Scroll to whichever element carried the id, not always the wrapper.
    const top =
      target.anchor.getBoundingClientRect().top + window.scrollY - getHeaderHeight();
    window.scrollTo({ top, behavior: "smooth" });
  }

  function activateFromHash() {
    if (!isMobile()) return;
    const slug = (window.location.hash || "").replace(/^#/, "");
    activateTarget(targetForSlug(slug));
  }

  // Deep links from other pages (/products/x#how-to-use).
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", activateFromHash);
  } else {
    activateFromHash();
  }

  // In-page navigation that changes the hash.
  window.addEventListener("hashchange", activateFromHash);

  // Intercept in-page anchor clicks so we open + offset-scroll even when the
  // hash is unchanged (hashchange won't fire on a re-click of the same link).
  document.addEventListener("click", (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const resolved = resolveLink(link);
    if (!resolved) return;

    // Custom tags open + scroll on every viewport; all other links are mobile-only.
    // Desktop RTE links keep native behavior (no preventDefault) — bail before it.
    const allowScroll = link.closest(".custom-tags") || isMobile();
    if (!allowScroll) return;

    // Stop the browser's native #-jump so we control the offset scroll.
    event.preventDefault();

    // Push whichever anchor actually resolved, so a reload lands in the same place.
    if (window.location.hash !== "#" + resolved.slug) {
      history.pushState(null, "", "#" + resolved.slug);
    }
    activateTarget(resolved.target);
  });
})();
